import script from "./TopViewedTable.vue?vue&type=script&setup=true&lang=js"
export * from "./TopViewedTable.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__